import { useContext } from 'react';
import {
  NotificationsSessionContext,
  NotificationsSessionContextValue,
} from './notifications-session-context';

/**
 * Access notifications session bootstrap state (provider id, Knock readiness).
 */
export function useNotificationsSessionContext(): NotificationsSessionContextValue {
  const value = useContext(NotificationsSessionContext);
  if (!value) {
    throw new Error(
      'useNotificationsSessionContext must be used within NotificationsSessionProvider',
    );
  }
  return value;
}

/**
 * Optional access when the provider may not be mounted (e.g. Storybook).
 */
export function useOptionalNotificationsSessionContext(): NotificationsSessionContextValue | null {
  return useContext(NotificationsSessionContext);
}
